import React from 'react';
import {useHistory} from 'react-router-dom';
import Tooltip from 'components/Tooltip';

const ListFiltersSourceBtn = (props) => {
    let history = useHistory();

    const {
        handleSelect, iconClasses, socialFilters, backgroundColor, type, count, loading, inHeader, name,
    } = props;

    return (
        <div
            className={`home-page-filters__source-item ${inHeader ? 'home-page-filters__source-item--in-header' : ''}`}>
            <Tooltip placement="bottom" wide tooltip={`Show/hide ${name} results`}>
                <div style={{position: 'relative', cursor: 'pointer'}}
                     onClick={() => handleSelect(type)}>
                    <div className={`filter-icon ${name === 'Instagram' ? 'filter-icon--instagram' : ''}`}
                         style={{backgroundColor: backgroundColor}}
                    >
                        <i className={iconClasses}/>
                    </div>
                    {socialFilters[type] === true &&
                    <div className={`filter-icon-checkmark ${name === 'Instagram' ? 'filter-icon--instagram' : ''}`}
                         style={{backgroundColor: backgroundColor}}
                    >
                        <i className="fas fa-check"/>
                    </div>
                    }
                </div>
            </Tooltip>
            <div className="filter-icon-count">{count}</div>
        </div>

    );
};

export default ListFiltersSourceBtn;
